'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@awesome.me/kit-94e593bf23/icons/sharp/solid';
import { faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { useAppContext } from '@/app/_lib/_context';
const SaleSideTab = () => {
  const $ = _c(8);
  const {
    saleData,
    dismissSaleTab
  } = useAppContext();
  let t0;
  if ($[0] !== dismissSaleTab) {
    t0 = e => {
      e.preventDefault();
      e.stopPropagation();
      dismissSaleTab();
    };
    $[0] = dismissSaleTab;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleDismiss = t0;
  if (!saleData?.hasSales) {
    return null;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FontAwesomeIcon icon={faTag} className="text-ink-gray-bg text-lg mb-2" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-xs font-medium text-ink-gray-bg whitespace-nowrap" style={{
      writingMode: "vertical-rl"
    }}>Sale</span>;
    t3 = <div className="w-4 border-t border-gray-10 mt-2" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FontAwesomeIcon icon={faXmark} className="text-base" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== handleDismiss) {
    t5 = <Link href="/pages/category555/sale" className="fixed right-0 bottom-[6rem] md:right-auto md:left-0 md:bottom-auto md:top-1/2 md:-translate-y-1/2 w-[2rem] bg-gray-7 rounded-l-md md:rounded-l-none md:rounded-r-md shadow-[-4px_4px_8px_-2px_rgba(0,0,0,0.15)] flex flex-col items-center pt-3 pb-1 z-[999] hover:opacity-80 transition-opacity group">{t1}{t2}{t3}<button onClick={handleDismiss} className="text-ink-light-gray-bg hover:text-ink-gray-bg transition-colors" aria-label="Dismiss sale announcement">{t4}</button></Link>;
    $[6] = handleDismiss;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default SaleSideTab;